import { toast } from 'react-toastify';
import { checkResponse, fetchWithAuth } from '../../util';
import { AppThunk } from '../store';
import { ActorDto } from './actorDto';
import { addCustomActor, setCustomActors } from './actorSlice';
import { Actor } from '../../types';
import { addActor } from '../client/clientSlice';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const CUSTOM_ACTOR_URL = new URL('actor/custom', BASE_URL);
const SAVE_CUSTOM_ACTOR_FAILED = 'Failed to save the actor to database!';

function mapDtoToActor(dto: ActorDto[]): Actor[] {
  let actors: Actor[] = [];

  dto.forEach((actor) => {
    actors.push({
      userId: actor.userId,
      userType: 'actor',
      username: actor.username,
      prompt: actor.prompt,
      isCustomActor: actor.isCustomActor,
      owner: actor.owner,
    });
  });

  return actors;
}

export const getCustomActors =
  (owner: string | undefined): AppThunk =>
  async (dispatch) => {
    if (!owner) return;

    const url = new URL(`${CUSTOM_ACTOR_URL}/${owner}`, BASE_URL);
    const res = await checkResponse(fetchWithAuth(url), {
      toastOnApiError: true,
      toastOnFetchError: true,
    });
    if (res) {
      const data: ActorDto[] = await res.json();
      const customActors = mapDtoToActor(data);
      dispatch(setCustomActors(customActors));

      customActors.forEach((customActor) => {
        dispatch(
          addActor({
            userId: customActor.userId,
            userType: 'actor',
            username: customActor.username,
            prompt: customActor.prompt,
            isCustomActor: customActor.isCustomActor,
          })
        );
      });
    }
  };

export const saveCustomActor =
  (actor: Actor): AppThunk =>
  async (dispatch) => {
    const res = await checkResponse(
      fetchWithAuth(CUSTOM_ACTOR_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(actor),
      }),
      { toastOnApiError: true, toastOnFetchError: true }
    );

    if (res) {
      const body: ActorDto = await res.json();
      const successMessage = `${body.username} is successfully saved to the database!`;
      toast.success(successMessage);
      dispatch(
        addActor({
          userId: body.userId,
          userType: 'actor',
          username: body.username,
          prompt: body.prompt,
          isCustomActor: body.isCustomActor,
        })
      );
      dispatch(
        addCustomActor({
          userId: body.userId,
          userType: 'actor',
          username: body.username,
          prompt: body.prompt,
          isCustomActor: body.isCustomActor,
        })
      );
    } else {
      toast.error(SAVE_CUSTOM_ACTOR_FAILED);
    }
  };
